import { loadGooglePlacesApi } from "./load-api";
import {
  expireGooglePlacesSessionToken,
  getGooglePlacesSessionToken,
} from "./session-token";

const CACHE: {
  placesService?: google.maps.places.PlacesService;
} = {};

export async function getGooglePlacesDetails({
  sessionToken,
  useSessionToken,
  ...options
}: Omit<google.maps.places.PlaceDetailsRequest, "language"> & {
  useSessionToken?: boolean;
}): Promise<google.maps.places.PlaceResult> {
  if (!CACHE.placesService) {
    await loadGooglePlacesApi();
    CACHE.placesService = new google.maps.places.PlacesService(
      document.createElement("div"),
    );
  }

  return await new Promise((resolve, reject) => {
    const request: google.maps.places.PlaceDetailsRequest = {
      region: "us",
      ...options,
      language: "en",
    };

    if (sessionToken) {
      request.sessionToken = sessionToken;
      expireGooglePlacesSessionToken(sessionToken);
    } else if (useSessionToken) {
      const sessionToken = getGooglePlacesSessionToken();
      if (sessionToken) {
        request.sessionToken = sessionToken;
        expireGooglePlacesSessionToken();
      }
    }

    CACHE.placesService?.getDetails(request, (result, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        reject(new Error(`Google Places getDetails error: "${status}"`));
      } else if (!result) {
        reject(new Error("No results returned by Google Places getDetails"));
      } else {
        resolve(result);
      }
    });
  });
}
